import {Directive, inject, input} from '@angular/core';

import {MonitoringService} from '../services';

@Directive({
  selector: '[appTrackEvent]',
  host: {
    '(click)': 'onTrackEvent()',
  },
})
export class AnalyticsDirective {
  readonly #monitoringService = inject(MonitoringService);

  readonly appTrackEvent = input.required<string>();
  readonly eventProperties = input<{ [key: string]: any }>();

  onTrackEvent() {
    console.log('Logging: ',this.appTrackEvent(), this.eventProperties())
    this.#monitoringService.logEvent(this.appTrackEvent(), this.eventProperties());
  }
}
